import { and, converge, ifElse } from 'ramda';

import { getOfferId } from 'app/router/selectors';
import { translationForKey } from 'app/features/localization/selectors';
import { isDirectToPay } from 'app/features/user/selectors';

const isDirectToPayOffer = converge(and, [getOfferId, isDirectToPay]);

const metaTitle = ifElse(
  isDirectToPayOffer,
  translationForKey('offer_meta_title_directtopay'),
  ifElse(
    getOfferId,
    translationForKey('offer_meta_title'),
    translationForKey('landing_meta_title'),
  ),
);

const metaDescription = ifElse(
  isDirectToPayOffer,
  translationForKey('offer_meta_description_directtopay'),
  ifElse(
    getOfferId,
    translationForKey('offer_meta_description'),
    translationForKey('landing_meta_description'),
  ),
);

const metaKeywords = ifElse(
  isDirectToPayOffer,
  translationForKey('offer_meta_keywords_directtopay'),
  ifElse(
    getOfferId,
    translationForKey('offer_meta_keywords'),
    translationForKey('landing_meta_keywords'),
  ),
);

export { metaTitle, metaDescription, metaKeywords };
